/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* EsLint is unable to read a rule with a dynamic property like role={isRadioGroup ? "radio" : "checkbox"} */
import React, { FC } from "react";
import { IconCheckbox } from "../icons/IconCheckBox";
import { IconRadio } from "../icons/IconRadio";
import styles from "./FilterOption.module.scss";

export interface FilterOptionProps {
    label: string;
    value: string;
    isSelected: boolean;
    onSelect: (value: string) => void;
    isRadioGroup?: boolean;
}

/**
 * `FilterOption` is a functional component that renders a selectable option
 * within a filter navigation menu. It supports both radio and checkbox
 * selection types, determined by the `isRadioGroup` prop.
 */
export const FilterOption: FC<FilterOptionProps> = ({
    label,
    value,
    isSelected,
    onSelect,
    isRadioGroup
}) => {
    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onSelect(value);
        }
    };

    return (
        <div
            className={styles.optionContainer}
            onClick={() => onSelect(value)}
            onKeyDown={handleKeyPress}
            role={isRadioGroup ? "radio" : "checkbox"}
            aria-checked={isSelected}
            tabIndex={0}
        >
            <div className={styles.iconWrapper}>
                {isRadioGroup ? (
                    <IconRadio isSelected={isSelected} />
                ) : (
                    <IconCheckbox isSelected={isSelected} />
                )}
            </div>
            <span className={styles.optionLabel}>{label}</span>
        </div>
    );
};
